module.exports = __webpack_public_path__ + "img/oval-red.bc8d55f0.svg";